import {Route, Routes} from 'react-router-dom';

import {AccountingModule} from '@dms/accounting';
import {AnalyticsModule} from '@dms/analytics';
import {BusinessCaseModule} from '@dms/business-case';
import {CustomerModule} from '@dms/customer';
import {DemoModule} from '@dms/demo';
import {EmployeeModule} from '@dms/employee';
import {ImportModule} from '@dms/import';
import {InspectionModule} from '@dms/inspection';
import {InterestModule} from '@dms/interest';
import {MyProfileModule} from '@dms/my-profile';
import {OpportunitiesKanbanModule} from '@dms/opportunities-kanban';
import {QuickPurchaseModule} from '@dms/quick-purchase';
import {RentalOrderModule} from '@dms/rental-order';
import {redirectRoute, restrictedAreaRoutes} from '@dms/routes';
import {SettingsModule} from '@dms/settings/core';
import {ErrorPage, RestrictedArea} from '@dms/shared';
import {SourcingModule} from '@dms/sourcing';
import {TaskManagerModule} from '@dms/task-manager';
import {TiresInventoryModule} from '@dms/tires-inventory';
import {VehiclesModule} from '@dms/vehicle';
import {useWarehouseModule} from '@dms/warehouse/routes';
import {useWorkshopModule} from '@dms/workshop';

import {purgeCache} from 'features/rtkq-persist';

import {useRegisterModules} from '../../hooks/useRegisterModules/useRegisterModules';
import {Redirect} from '../../pages/Redirect/Redirect';
import {Layout} from '../Layout/Layout';
import {flattenMenuItems} from '../Layout/utils/flattenMenuItems';
import {CoreModule} from './components/CoreModule';

export function ModulesContainer() {
  const workshopModule = useWorkshopModule();
  const warehouseModule = useWarehouseModule();

  const modulesCache = useRegisterModules([
    CoreModule,
    SourcingModule,
    TaskManagerModule,
    QuickPurchaseModule,
    CustomerModule,
    VehiclesModule,
    BusinessCaseModule,
    RentalOrderModule,
    InterestModule,
    DemoModule,
    workshopModule,
    warehouseModule,
    AccountingModule,
    InspectionModule,
    SettingsModule,
    AnalyticsModule,
    EmployeeModule,
    TiresInventoryModule,
    ImportModule,
    OpportunitiesKanbanModule,
    MyProfileModule({purge: purgeCache}),
  ]);

  if (!modulesCache) {
    return null;
  }

  return (
    <Routes>
      <Route
        element={
          <Layout
            menuItems={modulesCache.menuItems}
            createMenuItems={modulesCache.createMenuItems}
            menuItemsById={flattenMenuItems(modulesCache.menuItems)}
            data-testid="layout"
          />
        }
      >
        {modulesCache.routes.map((props, index) => {
          const {element, path, ...routeProps} = props;
          return <Route key={`${path}-${index}`} {...routeProps} path={path} element={element} />;
        })}
        <Route path={restrictedAreaRoutes.home} element={<RestrictedArea />} />
        <Route path={redirectRoute} element={<Redirect />} />
      </Route>
      <Route key="app-routes-error" path="*" element={<ErrorPage message="Page Not Found" />} />
    </Routes>
  );
}
